import { cn } from "../../../../../../lib/utils";
import { motion } from "framer-motion";
import { DAYS_OF_WEEK } from "../../../types";

export default function MonthlyCalendarSkeleton() {
  const daysCells = () => {
    return (
      <div className="h-full w-full flex flex-col">
        <div className="grid grid-cols-7 text-secondary">
          {DAYS_OF_WEEK.map((day) => (
            <div
              key={day}
              className="p-2 text-sm font-semibold text-center min-w-[100px] select-none"
            >
              {day}
            </div>
          ))}
        </div>

        {/* Calendar grid */}
        <div className="grid grid-rows-6 flex-1 rounded-lg overflow-hidden border border-border">
          {[...Array(6)].map((_, rowIndex) => (
            <div
              key={rowIndex}
              className="grid grid-cols-7 border-border h-full"
            >
              {[...Array(7)].map((_, colIndex) => {
                return (
                  <div
                    key={`${rowIndex}-${colIndex}`}
                    className={cn(
                      "p-2 h-full transition-all duration-300",
                      "bg-background text-secondary",
                      rowIndex !== 5 && "border-b border-input",
                      colIndex !== 6 && "border-r border-input"
                    )}
                  >
                    <motion.div
                      className={cn(
                        "text-sm p-1 w-7 h-7 flex items-center justify-center mb-2"
                      )}
                      animate={{
                        opacity: [0.5, 1, 0.5],
                      }}
                      transition={{
                        duration: 2,
                        repeat: Infinity,
                      }}
                    >
                      <motion.div className="w-full h-full bg-dark rounded-full" />
                    </motion.div>
                    <motion.div
                      className="w-full h-8 bg-dark rounded-xs"
                      animate={{
                        opacity: [0.5, 1, 0.5],
                      }}
                      transition={{
                        duration: 2,
                        repeat: Infinity,
                      }}
                    />
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <motion.div
      className="flex flex-col gap-4 h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex-1 min-h-0">{daysCells()}</div>
    </motion.div>
  );
}
